import { Common } from './../../../common/common';
import { Router } from '@angular/router';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { HelpViewModel } from './../../../VIewModels/TowLocateViewModels/HelpViewModel';
import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
@Component({
  selector: 'app-help-page',
  templateUrl: './help-page.component.html',
  styleUrls: ['./help-page.component.css']
})
export class HelpPageComponent implements OnInit {
  public commonFunctions = new Common();
  public helpModel = new HelpViewModel();
  public form:FormGroup;
  public formFlag=true;
  public sucess=false;
  public failed=false;
  get fname(){
    return this.form.get('fname');
  }
  get femail(){
    return this.form.get('femail');
  }
  get fmessage(){
    return this.form.get('fmessage');
  }
  get fphone(){
    return this.form.get('fphone');
  }
  constructor(private formBuilder:FormBuilder,public client: HttpClient,  public router:Router,
    private spinnerService: Ng4LoadingSpinnerService) { }

  ngOnInit() {
        
    this.form = this.formBuilder.group({
      fname:[null,Validators.required],
      femail:[null,Validators.required],
      fmessage:[null,Validators.required],
      fphone:['']
    });
  }

  public GoBack()
  {
    this.router.navigate([`/HomePage`])

  }
 public Submit()
  {
    if(this.form.valid)
    {
      this.spinnerService.show();

      const httpOptions =
      {
       headers: new HttpHeaders({
         'Content-Type':  'application/json',
       })
   };
   this.client.post<boolean>("https://towlienapiprod.azurewebsites.net/api/FindMyCar/PostFeedback",JSON.stringify(this.helpModel),httpOptions).subscribe(data=>{
      if (data) {
        this.spinnerService.hide();
        this.formFlag=false;
        this.sucess=true;
      }
      else
      {this.spinnerService.hide();
        this.formFlag=false;
        this.failed=true;
      }
   });
  
    }
    else
    {
      this.commonFunctions.validateAllFormFields(this.form);

    }

  }

}



// WEBPACK FOOTER //
// ./src/app/Components/TowLocate/help-page/help-page.component.ts